<h4>
    Internal server error - refreshing the page will make the error to disappear!
</h4>
<ng-container>
    <h5 style="color: red;" color="warn">Error: {{error?.message}}</h5>
    <p>Note: If you are seeing this, then Angular is probably not to blame</p>
    <p>What to do next?</p>

    <ol>
        <li>Open the chrome dev tools</li>
        <li>Inspect the network tab</li>
        <li>Check the failing request</li>
        <li>Examine the request URL - make sure it is correct</li>
        <li>Reproduce the error in Postman - if wee the same response, the the issue is not with Angular</li>
    </ol>

    <p>Following is the stack tarace - this is where your investigation should start!</p>
    <code style="color: red;" color="warn">{{error?.details}}</code>
</ng-container>